type IOpcaoDocumento = 'cpf' | 'cnpj';
export function formatarData(data: Date | string): string {
  if (!data) {
    return '---';
  }
  const dataFormatada = new Date(data).toLocaleString('pt-BR');
  return dataFormatada.toString().replace(',', ' ');
}

export function formatarPlaca(placa: string): string {
  if (!placa) {
    return '---';
  }
  const placaUpperCase = placa.toUpperCase();
  return placaUpperCase
    .split('|')
    .map(placa => {
      placa = placa.trim();
      if (placa.length === 7) {
        return `${placa.substring(0, 3)}-${placa.substring(3, 7)}`;
      }
      return placa;
    })
    .join(' | ');
}

export function isPlacaValida(value: string): boolean {
  let hasLetter = false;
  let hasNumber = false;

  for (let i = 0; i < value.length; i++) {
    if (/^[A-Za-z]$/.test(value[i])) {
      hasLetter = true;
    } else if (/^[0-9]$/.test(value[i])) {
      hasNumber = true;
    }

    if (hasLetter && hasNumber) {
      return true;
    }
  }

  return false;
}

export function isMultiplasPlacasValidas(...values: string[]): boolean {
  return values.every(value => {
    let hasLetter = false;
    let hasNumber = false;

    for (let i = 0; i < value.length; i++) {
      if (/^[A-Za-z]$/.test(value[i])) {
        hasLetter = true;
      } else if (/^[0-9]$/.test(value[i])) {
        hasNumber = true;
      }

      if (hasLetter && hasNumber) {
        return true;
      }
    }

    return false;
  });
}

export function formatarCpfCnpj(value: string, type: IOpcaoDocumento) {
  if (type == 'cpf') {
    value = value.replace(/\D/g, '');

    if (value.length <= 11) {
      value = value.padStart(11, '0');
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
  }

  if (type == 'cnpj') {
    value = value.replace(/\D/g, '');

    if (value.length <= 14) {
      value = value.padStart(14, '0');
      return value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
      );
    }
  }

  return value;
}

export function formatarTelefone(value: string) {
  value = value.replace(/\D/g, '');

  if (value.length === 11) {
    return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if (value.length === 10) {
    return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  return value;
}

export function validarIsNullOrEmpty(value: any): boolean {
  const invalid = ['', null, undefined, NaN];

  return invalid.includes(value);
}

export function tratarIsNullOrEmpty(value: any): any {
  const invalid = ['', null, undefined, NaN, '---', 0];

  return invalid.includes(value) ? null : value;
}

export function removeHyphen(value: string): string {
  return value.replace(/-/g, '');
}

export function converterDecimalBrasilParaAmericano(valor: string): number {
  const valorConvertido = valor.replace(/\./g, '').replace(',', '.');
  return parseFloat(valorConvertido);
}
